//#region Styles
import {
    ContainerParts 
} from "components/styles";
//#endregion
//#region Components
import ResumeStep1 from "./components/ResumeStep1/ResumeStep1";
import ResumeStep2 from "./components/ResumeStep2/ResumeStep2";
//#endregion

const AcadReinforceDetail = ({
    dataRelatedToForm,
    acadReinforceResumeData, 
    toStep, isDetailAcadReinforce = false,
}) => {
    return (
        <ContainerParts>
            {acadReinforceResumeData && (
            <>
            <ResumeStep1 
                dataRelatedToForm={dataRelatedToForm}
                data={acadReinforceResumeData?.step1}
                toStep1={isDetailAcadReinforce ? null : () => toStep(1)}
                isDetailEvent={isDetailAcadReinforce}/>
            <ResumeStep2 
                dataRelatedToForm={dataRelatedToForm}
                data={acadReinforceResumeData?.step2}
                toStep2={isDetailAcadReinforce ? null : () => toStep(2)}
                isDetailEvent={isDetailAcadReinforce}/>
            </>
            )}
        </ContainerParts>
    )
}


export default AcadReinforceDetail;